import Table from '@/components/ui/table/table';
export default Table;
